export default {
    min: null,
    max: null,
    loading: false,
    type: 'max',
    cbs: [],
    time: 0,
}